import React, {Component} from 'react';
import {Breadcrumb, BreadcrumbItem,  Col, Container, Row} from "reactstrap";
import {Link} from "react-router-dom";
import UserPanelMenu from "../../components/user/UserPanelMenu";
import {API_URL} from "../../config/Config";
import BootstrapTable from 'react-bootstrap-table-next';
import axios from "axios/index";
import {connect} from "react-redux";
import SweetAlert from 'sweetalert2-react';
import axiosRetry from 'axios-retry';
import SectionLoader from "../../components/loader/SectionLoader";
axiosRetry(axios, { retries: 3 });


class UserCartsList extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1',
            data:[],
            loading:false,
            isSave:false,
            type:'success',
            title:'داده ها با موفقیت دریافت شد'
        };
    }
    async componentDidMount(){
        await this.getDataFromApi();
    }
    async getDataFromApi() {
        try {
            let response = await axios.get(`${API_URL}user-order?api_token=${this.props.user.apiToken}`);
            let data = await response.data.data;
            await this.setState({data});
            /*this.setState({
                isSave:true,
                type:'success',
                title:'داده ها با موفقیت دریافت شد'
            });*/
        }catch (e) {
            let apiError = await e.response;

            if (apiError === undefined) {
                console.log(e);
            } else {
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({apiErrorText});
            }

            this.setState({
                isSave:true,
                type:'error',
                title: "خطایی در هنگام دریافت اطلاعات رخ داد"
            });
        }
        console.log("done");
        this.setState({loading: true});
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {

/*        function actionBtns(cell, row, rowIndex) {
            return (
                <ButtonGroup>
                    <Link to={`/merchant/${cell}`} className='btn btn-sm btn-primary'><i className="fa fa-search"/></Link>
                    {/!*<Button size="sm" color="warning" onClick={()=>console.log(row)}><i className="fa fa-edit"/></Button>*!/}
                    <Link to={`/edit-job/${cell}`} className='btn btn-sm btn-warning'><i className="fa fa-edit"/></Link>
                    <Button size="sm" color="danger" onClick={()=>alert(cell)} ><i className="fa fa-trash"/></Button>

                </ButtonGroup>
            );
        }*/
        function activeIndicator(cell, row, rowIndex) {
            if (cell === '1') {
                return (<i className='fa fa-check' style={{fontSize: 20, color: 'green'}}/>);
            }else{
                return (<i className='fa fa-close' style={{fontSize: 20, color: 'red'}}/>);
            }
        }
      /*  const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
        };*/
        const columns = [{
            dataField: 'id',
            text: 'شناسه',
            align: 'center',
            headerAlign: 'center',
            hidden: true
        }, {
            dataField: 'cart.title',
            text: 'عنوان',
        },{
            dataField: 'final_price',
            text: 'قیمت ',
        }, {
            dataField: 'cart.copoun_count',
            text: 'تعداد کوپن',
        }, {
            dataField: 'cart.duration',
            text: 'مدت اعتبار (روز)',
        },
            {
            dataField: 'is_active',
            text: 'وضعیت',
            formatter: activeIndicator,
        }, {
            dataField: 'expierd_at',
            text: 'زمان اتمام بسته',
        }, {
            dataField: 'created_at',
            text: 'تاریخ خرید',
        }];
        return (
            <div className="pt-5 mt-5">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">کاربر</Link></BreadcrumbItem>
                        <BreadcrumbItem active>خریدهای من</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12' className="">
                            <UserPanelMenu activeElement="3"/>
                        </Col>
                        <Col md='9' sm='12'>
                            <div className="panel panel-default white">
                                <div className="portlet-title">
                                    <h2>خریدهای من</h2>
                                </div>
                                <div className="portlet-body p-3">

                                    <Row>
                                        <Col md='12'>
                                            {!this.state.loading ? <SectionLoader type="bubbles" color="#f6581d"/> :
                                                <BootstrapTable
                                                    classes="data-table"
                                                    keyField='id'
                                                    data={this.state.data}
                                                    columns={columns}
                                                    bordered={false}
                                                    noDataIndication="موردی یافت نشد."
                                                    // selectRow={ selectRow }
                                                />
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <SweetAlert
                    show={this.state.isSave}
                    title={this.state.title}
                    type={this.state.type}
                    showConfirmButton={true}
                    onConfirm={() => this.setState({ isSave: false })}
                />

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    }
}

export default connect(mapStateToProps,null)(UserCartsList);


// WEBPACK FOOTER //
// ./src/containers/products/UserCartsList.js